import { Component } from '@angular/core';
import { NavController,App} from 'ionic-angular';
import { SubmitPhonePage } from './submitphone'
import { AppState } from '../../../app/app.global';
import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';
import { HttpService } from '../../../providers/service/httpservice';
import { LOAD_SECURITY_INFO} from '../../../providers/config/serviceurl';

@Component({
  selector: 'bind-phone-page',
  templateUrl: 'bindphone.html'
})
export class BindPhonePage {
	bindPhone:any="";
	user:any =null;
	constructor (public navCtrl: NavController,public global: AppState,public appCtrl: App,
		private httpService:HttpService) {
		//this.bindPhone = StorageService.getObj("bindPhone");
		//绑定手机时判断是否登录，未登录跳转到登录地址
		this.user = StorageService.getObj('currentUser');
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
      StorageService.remove('currentUser');
      this.appCtrl.getRootNav().push(LoginPage);
    }else{
			//获取绑定的手机号
			this.getBindPhone();
		}
	}

	getBindPhone(){
		let params = {"username":this.user.username};
		this.httpService.get2(LOAD_SECURITY_INFO,params).then(anyObj =>this.handleBindPhone(anyObj));
	}

	handleBindPhone(obj:any){
		if(obj.authentication=='success'){
			let phone = obj.securityInfo.mobileinfo;
			if (phone==null||phone==""||phone==undefined){
				this.bindPhone="您还未绑定安全手机";
			}else{
				this.bindPhone = phone;
			}
		}
	}

	collback= (params)=>{
		return new Promise((resolve, reject) => {
			if (typeof(params)!='undefined'){
				resolve('ok');
				
				this.getBindPhone();
			}else{
				reject(Error('error'));
			}
			
		});
	}

	openSubmitPhonePage(){
		this.navCtrl.push(SubmitPhonePage,{"bindPhone":this.bindPhone,collback:this.collback});
	}
}



// WEBPACK FOOTER //
// ./src/pages/about/bind/bindphone.ts